import React from "react";
import arrowRight from "../../assets/icons/arrow-right-black.svg";
import { RecursiveDropdownProps } from "./segment-interface";
import "./DynamicNestedDropdownSegmentSection.scss";
import "./CreateSegment.scss";
import { useCountryList } from "../../services/okta";

export const RecursiveDropdown: React.FC<RecursiveDropdownProps> = ({
  items,
  expandedMap,
  toggleExpand,
  activePath,
  handleClick,
  parentPath = [],
  isItemDisabled,
}) => {
  const { data: countryData } = useCountryList();

  return (
    <ul className={`dropdown`}>
      {items.map((item, index) => {
        const currentPath = [...parentPath, item.label];
        const pathKey = currentPath.join("/");
        const isExpanded = expandedMap[pathKey];
        const isActive = activePath.includes(pathKey);
        const disabled = isItemDisabled?.(item, currentPath) ?? false;


        if (!countryData?.map((country) => country.name)?.includes("USA") && item.label === "Stirista Attributes (USA only)") {
          return null;
        }

        return (
          <li key={index} className={isActive ? "active" : ""}>
            <div
              className="dropdown__item"
              style={
                disabled
                  ? { opacity: 0.5, cursor: "not-allowed", pointerEvents: "none" }
                  : undefined
              }
              onClick={(e) => {
                e.stopPropagation();
                const currentPath = [...parentPath, item.label];
                if (item.children) {
                  toggleExpand(pathKey, currentPath, item.children!, e.currentTarget);
                } else {
                  handleClick(currentPath);
                }
              }}
            >
              <div>
                <div className="dropdown__label">{item.label}</div>
                {item.description && (
                  <div className="dropdown__description">{item.description}</div>
                )}
              </div>
              {item.children && (
                <span
                  className={`dropdown__arrow ${isExpanded ? "expanded" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleExpand(pathKey, parentPath, item.children!, e.currentTarget);
                  }}
                >
                  <img src={arrowRight} alt="arrow" />
                </span>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};
